import axios from '@axios';

const base = '/api/v1/additional-visitors';
const baseVisit = '/api/v1/visits';
const baseSafeguarding = '/api/v1/additional-visitors-safeguarding';

export default {
  getAdditionalVisitorsForVisit(visitId){
    return axios.get(`${base}/for-visit/` + visitId);
  },
  getAdditionalVisitorsForSocialVisit(visitId){
    return axios.get(`${base}/for-social-visit/${visitId}`);
  },
  getAdditionalVisitor(additionalVisitorId){
    return axios.get(`${base}/single/` + additionalVisitorId);
  },
  getAdditionalVisitorsSafeguardingStatus(additionalVisitorId){
    return axios.get(`${baseSafeguarding}/for/` + additionalVisitorId + `/status`);
  },
  getAdditionalVisitorsSafeguardingHistory(additionalVisitorId) {
    return axios.get(`${baseSafeguarding}/for/` + additionalVisitorId);
  },
  getAdditionalVisitors(visitorId){
    return axios.get(`${base}/for-visitor/` + visitorId);
  },
  getAdditionalVisitorsForVisitorSocialVisit(visitorId){
    return axios.get(`${base}/for-visitor/${visitorId}/social-visit`);
  },
  createSafeguarding(details){
    return axios.post(`${baseSafeguarding}/create`, details);
  },
  requestAdditionalVisitorId(visitorId){
    return axios.post(`${base}/request/additional-id/` + visitorId);
  },
  addAdditionalVisitorToVisit(visitId, additionalVisitorId){
    return axios.post(`${baseVisit}/additional-visitor/add/` + visitId, {
      additional_visitor_id: additionalVisitorId,
    });
  },
  removeAdditionalVisitorFromVisit(visitId, additionalVisitorId){
    return axios.post(`${baseVisit}/additional-visitor/remove/` + visitId, {
      additional_visitor_id: additionalVisitorId,
    });
  },
  createOnDemandAdditionalVisitor(visitorId, dto) {
    return axios.post(`${base}/create/on-demand/${visitorId}`, dto);
  },
};
